<template>
  <div class="setting" :class="{active: open}">
    <div class="title main-setting-title">
      <a href="#" class="back-to-result" @click.prevent="this.$emit('settingstoggle', false)"></a>
      Settings
    </div>
    <div v-if="!setting.extensionInstalled" class="text-center">
      <h2>GET YOUR CASHBACK</h2>
      <p>Never miss a deal again with our extension</p>
      <br>
      <p><a :href="isEdge ? edgeLink : chromeLink" class="btn-main">Get extension</a></p>
      <br>
      <p><img src="../assets/img/install-ext-image.png" alt="install extension"></p>
    </div>
    <div v-else>
      <div class="setting-block">
        <div class="setting-item">
          <h3 class="setting-title bold">Auto-Detect</h3>
          <div class="setting-toggler">
            <input type="checkbox" class="toggler" :checked="setting.autoDetect" @change="changeSetting('autoDetect', $event);" />
          </div>
          <div class="setting-text">With this feature enabled, we can detect and alert you of any money-saving opportunities around, wherever you are on the web</div>
        </div>
        <div class="setting-item">
          <h3 class="setting-title">Allow Floating alert</h3>
          <div class="setting-toggler">
            <input type="checkbox" class="toggler" :disabled="!setting.autoDetect" :checked="setting.showFloatPopup" @change="changeSetting('showFloatPopup', $event)" />
          </div>
        </div>
        <div class="setting-item">
          <h3 class="setting-title">Allow Notification</h3>
          <div class="setting-toggler">
            <input type="checkbox" class="toggler" :disabled="!setting.autoDetect" :checked="setting.showNotification" @change="changeSetting('showNotification', $event)" />
          </div>
        </div>
      </div>
      <div class="setting-block">
        <div class="setting-item">
          <h3 class="setting-title">Allow notification for new deals</h3>
          <div class="setting-toggler">
            <input type="checkbox" class="toggler" :checked="setting.enableNotification" @change="changeSetting('enableNotification', $event)" />
          </div>
          <div class="setting-text">You can get secret deals such as coupons and cashback</div>
        </div>
      </div>
      <div class="text-center">
        <a href="https://cashbackalert.net/" class="nav-link link" target="_blank">How does it work?</a>
      </div>
    </div>
    <div class="setting-refresh" v-if="setting.lastRefresh">
      <p>Last refresh:</p>
      <p><b>{{setting.lastRefresh}}</b></p>
    </div>
    <div class="setting-footer">
      <a href="https://cashbackalert.net/privacy/" class="footer-link" target="_blank">Privacy Policy</a>
      <a href="https://cashbackalert.net/terms/" class="footer-link" target="_blank">EULA</a>
      <a href="https://cashbackalert.net/#faq" class="footer-link" target="_blank">FAQ</a>
      <a href="https://cashbackalert.net/contact/" class="footer-link" target="_blank">Contact Us</a>
    </div>
  </div>
</template>

<script>
import { useToast, POSITION } from "vue-toastification";
import {reportEvent, chromeExtensionLink, edgeExtensionLink, } from "../utils";
export default {
  props: ['open', 'settings'],
  name: 'Settings',
  data: function (){
    return {
      setting: this.settings
    }
  },
  created() {
    this.chromeLink = chromeExtensionLink
    this.edgeLink = edgeExtensionLink
    this.isEdge = window.navigator.userAgent.indexOf("Edg") > -1
  },
  methods: {
    changeSetting(name, event) {
      if(name === 'showFloatPopup'){
        this.setting.showFloatPopup = event.target.checked
        this.setting.showNotification = !event.target.checked
        window.postMessage({
              sender: 'caSite',
              message: {
                showFloatPopup: event.target.checked,
                showNotification: !event.target.checked,
              }
            },
            "*");
      } else if(name === 'showNotification'){
        this.setting.showNotification = event.target.checked,
        this.setting.showFloatPopup = !event.target.checked,
        window.postMessage({
              sender: 'caSite',
              message: {
                showNotification: event.target.checked,
                showFloatPopup: !event.target.checked,
              }
            },
            "*");
      } else {
        window.postMessage({
              sender: 'caSite',
              message: {
                [name]: event.target.checked,
              }
            },
            "*");
      }

      const toast = useToast();
      if(name === 'autoDetect'){
        this.setting.autoDetect = event.target.checked
        if(this.setting.autoDetect){
          this.setting.showFloatPopup = false
          this.setting.showNotification = true
        } else  {
          this.setting.showFloatPopup = false
          this.setting.showNotification = false
        }
      }
      toast("Changes saved successfully!", { position: POSITION.BOTTOM_RIGHT });
      this.$emit('changesettings', {[name]: event.target.checked})
      reportEvent('settings', {
        action: 'change',
        [name]: event.target.checked
      })
    },
    refreshDeals() {
      this.$emit('refreshdeals')
      // refresh data on site
      // refresh data at extension
      window.postMessage({
            sender: 'caSite',
            message: {
              refresh: true,
            }
          },
          "*");
    }
  }
}
</script>

<style lang="scss">
  .Vue-Toastification__container .Vue-Toastification__toast--default {
    background: #00C6A2;
  }

  .setting-refresh {
    margin-top: 20px;
  }

</style>